import { Image, system } from '@hover/blueprint';
import type { FlexProps } from '@hover/blueprint/chakra';
import { AspectRatio, Flex } from '@hover/blueprint/chakra';
import type { FunctionComponent } from 'react';
import React from 'react';

import { selectionStyles } from 'src/modules/designStudio/components/SelectionButton';

interface InspireMeCardProps extends FlexProps {
  isSelected: boolean;
  imgPath: string;
  onSelected: () => void;
}

export const InspireMeCard: FunctionComponent<InspireMeCardProps> = ({
  isSelected,
  imgPath,
  onSelected,
  ...props
}) => (
  <Flex
    className="template-item"
    flex={1}
    flexDirection="column"
    minWidth="120px"
    {...props}
  >
    <AspectRatio height="100%" ratio={1.33333}>
      <system.button
        {...selectionStyles({ isSelected })}
        borderRadius={300}
        cursor="pointer"
        flex={1}
        height="100%"
        onClick={onSelected}
        position="relative"
        width="100%"
      >
        <Image alt="" borderRadius="inherit" height="100%" src={imgPath} />
      </system.button>
    </AspectRatio>
  </Flex>
);
